import { IKizBoxDTO, IKizBoxGismtDTO, IKizDTO } from "../../libs/coreapi-dto/dirs/kiz"
import { DocumentType } from "../../@types/enumsGlobal";
import { IBaseDocumentItemKizDTO } from "../../libs/coreapi-dto/documents/base";
import { KizParsed } from "../../Business/Dictionaries/Kiz/KizParsed";
import { IKizOsuDTO } from "../../libs/coreapi-dto/dirs/KizOsu";

export const validateDuplicateKizs = (
    items: IBaseDocumentItemKizDTO[],
    barcode: string,
    documentType?: DocumentType,
    _kizs?: IKizDTO[],
    _kizBoxes?: IKizBoxDTO[],
    _kizOsuDtos?: IKizDTO[],
    _kizBoxesGisMt?: IKizBoxGismtDTO[]
) : boolean | null => {
    if (barcode === '') return false

    var decodedBarcode = KizParsed.decodedBarcode(barcode)
    var kizParsed = new KizParsed(decodedBarcode)
 
    var kizs = _kizs ?? items.flatMap(c => c?.kizs).filter(c => c !== undefined) as IKizDTO[] | null
    var kizBoxes = _kizBoxes ?? items.flatMap(c => c?.kizBoxes).filter(c => c !== undefined) as IKizBoxDTO[] | null
    var kizOsu = items.flatMap(c => c?.kizOsuDto).filter(c => c !== undefined && c !== null) as IKizOsuDTO[] | null
    var kizOsuDtos = _kizOsuDtos ?? items.flatMap(c => c?.kizOsuDtos).filter(c => c !== undefined && c !== null) as IKizDTO[] | null;
    var kizBoxesGisMt = _kizBoxesGisMt ?? items.flatMap(c => c?.kizBoxesGisMt).filter(c => c !== undefined) as IKizBoxGismtDTO[] | null

    if (kizParsed.isKiz) {
        const kizResult = kizs?.find(c => c?.gtinSGtin === kizParsed.gtinSgtin)
        if (kizResult) {
            if (documentType && documentType === DocumentType.disaggregation) return !kizResult.isTrusted
            return false
        }

        const kizOsuResult = kizOsu?.find(c => c?.gtinSGtin === kizParsed.gtinSgtin)
        if (kizOsuResult) return false

        const kizOsuDtoResult = kizOsuDtos?.find(c => c?.gtinSGtin === kizParsed.gtinSgtin);
        if (kizOsuDtoResult) return false;
    }   

    const kizBoxResult = kizBoxes?.find(c => c?.barcode === barcode)?.barcode
    const boxGismtResult = kizBoxesGisMt?.find(c => c?.barcode === barcode)?.barcode
    if (kizBoxResult || boxGismtResult) return false
    return true
}